class PopUp extends React.Component {
  constructor(props) {
    super(props);
  }
  Popup({
    heading,
    message,
    button_back,
    back_fn,
    call_to_action_fn,
    continue_fn,
    prop_message,
    button_text,
  }) {
    if (prop_message == 1) {
      return (
        <div className="popup-overlay">
          <div className="popup-card">
            <div className="popup-card__close" onClick={back_fn}>
              x
            </div>
            <h1 className="popup-card__heading">{heading}</h1>
            <hr className="popup-card__space" />
            <p className="popup-card__description">{message}</p>
            <div className="popup-card__CTA">
              <button
                className="popup-card__button-back"
                type="submit"
                onClick={back_fn}
                id="back"
                text="go back"
                title="go back"
              >
                {button_back}
              </button>
              <button
                className="popup-card__button-quick-pick"
                type="submit"
                onClick={call_to_action_fn}
                text="Quick Pick"
                id="quick-pick"
                title="quick pick remaining lines"
              >
                {button_text}
              </button>
            </div>
          </div>
        </div>
      );
    } else if (prop_message == 2) {
      return (
        <div className="popup-overlay">
          <div className="popup-card">
            <div className="popup-card__close" onClick={back_fn}>
              x
            </div>
            <h1 className="popup-card__heading">{heading}</h1>
            <hr className="popup-card__space" />
            <p className="popup-card__description">{message}</p>
            <div className="popup-card__CTA">
              <button
                className="popup-card__button-back"
                type="submit"
                onClick={back_fn}
                id="back"
                text="go back"
                title="go back"
              >
                {button_back}
              </button>

              <div className="btn__wrap">
                <button
                  className="popup-card__button-quick-pick"
                  type="submit"
                  onClick={continue_fn}
                  text="Quick Pick"
                  id="quick-pick"
                  title="quick pick remaining lines"
                  disabled=""
                >
                  {button_text}
                </button>
                <div className="loader">
                  <div className="loading"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <>
        <this.Popup
          amount_fn={this.props.popup_amount}
          back_fn={this.props.PopUpOnClick}
          button_back={this.props.popup_button_back}
          button_text={this.props.CTA_message}
          call_to_action_fn={this.props.quickPickSelected}
          call_to_action=""
          continue_fn={this.props.handleContinue}
          dash_redirect_fn={this.props.PopUpDashRedirect}
          dashboard_text={this.props.dashboard_button_text}
          development_mode={this.props.development_mode}
          handleChange={this.props.handleChange}
          heading={this.props.popup_heading}
          message={this.props.popup_message}
          number_fn={this.props.popup_number_value}
          play_again_fn={this.props.PopUpPlayAgain}
          play_now_fn={this.props.PopUpPlayNow}
          prop_message={this.props.popup_show}
        />
      </>
    );
  }
}
export default PopUp;
